<template>
    <div class="flex flex-col items-center justify-center flex-1 h-full p-4">
        <CircleX :size="48" class="text-red-500 dark:text-red-400 mb-4" />
        <p class="text-center">
            {{ $t('error.pleaseTryAgain') }}
        </p>
        <Button
            as="a"
            class="w-full md:w-auto mt-8"
            href="#login"
            severity="secondary"
            size="small"
            :label="$t('backToLogin')"
            variant="text" />
    </div>
</template>

<script lang="ts">
import { CircleX } from 'lucide-vue-next';

export default {
    components: {
        CircleX
    }
};
</script>
